module.exports = __webpack_public_path__ + "img/calendar-blur.c6707e65.svg";